<template>
  <span v-if="inline">
    <v-progress-circular
      v-if="isLoading"
      v-bind="$attrs"
      indeterminate
    />
    <slot
      v-if="shoudShowContent"
      :res="res"
    />
  </span>

  <div v-else>
    <v-progress-circular
      v-if="isLoading"
      v-bind="$attrs"
      indeterminate
    />
    <slot
      v-if="shoudShowContent"
      :res="res"
    />
  </div>
</template>

<script>
export default {
  name: 'AsyncComponent',
  props: {
    fn: {
      type: Function,
      default: null
    },

    loading: {
      type: Boolean,
      default: false
    },

    inline: {
      type: Boolean,
      default: false
    },

    remainContent: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loadComplete: false,
      res: null
    };
  },

  computed: {
    isLoading() {
      return this.loading || !this.loadComplete;
    },
    shoudShowContent() {
      return !this.isLoading || this.remainContent;
    }
  },

  async mounted() {
    if (this.fn) {
      this.res = await this.fn();
    }

    this.loadComplete = true;
    this.$nextTick(() => {
      this.$emit('load');
    });
  }
};
</script>
